import {
  FETCH_PUBLICACIONES,
  FETCH_PUBLICACION,
  EDIT_PUBLICACION,
  FETCH_TIPOPUBLICACION,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
  FETCH_ESTADOSVARIACIONES,
  FETCH_MARCAS,
  FETCH_CATEGORIAS,
  FETCH_MOTIVOS,
  SET_FILTRO_PUBLICACIONES,
  SE_MODIFICARON_IMAGENES,
  LOADING_PUBLICACIONES,
  RESET_PUBLICACIONES,
  SET_IMAGES_UPLOADER,
  HAY_CAMBIOS_EN_IMAGENES,
  RESET_MARCA_Y_CATEGORIA,
  RESET_LIST_PUBLICACIONES,
  UPDATE_PUBLICACIONES_ESTADO,
  FETCH_ALICUOTA_IVA,

  FETCH_ATRIBUTOSCATEGORIA,
  FETCH_VALORESATRIBUTO,
  FETCH_ESTRUCTURAATRIBUTOSVALORES,
  FETCH_AGRUPAMIENTOS,
  FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO,
  SET_PRODUCTOVALORES,
  SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS
} from './types';

import {
  fetchPublicacionesApi,
  fetchPublicacionApi,
  fetchTipoPublicacionApi,
  fetchVariacionesApi,
  fetchMarcasApi,
  fetchCategoriasApi,
  fetchCategoriaApi,
  fetchMotivosRevisionApi,
  fetchPublicacionesEncabezadoApi,
  fetchAlicuotaIvaApi,
  fetchAtributosCategoriaApi,
  fetchValoresAtributoApi,
  fetchEstructuraAtributosValoresApi,
  fetchAgrupamientosApi,
  fetchAtributosPorCategoriaAgrupamientoApi,
  fetchPublicacionPorSkuMarketApi,
  fetchMarcaApi
} from '../api/axios';

import {
  nuevaPublicacion,
  mapPublicacion,
  getIdEstadoPublicacion,
  normalizeEstadoPublicacion,
  resetPublicacion
} from '../helper/publicacionHelper'

let lastPublicacionesEncabezadoKey = null;
let lastPublicacionesEncabezadoAt = 0;
let lastPublicacionesEncabezadoData = null;

const normalizeOptionalSellerParam = (params) => {
    if (!params || typeof params !== 'object') {
        return params;
    }

    ['idSeller', 'IdSeller'].forEach((key) => {
        if (!Object.prototype.hasOwnProperty.call(params, key)) {
            return;
        }

        const rawValue = params[key];
        const trimmedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

        if (trimmedValue === '' || trimmedValue == null) {
            delete params[key];
            return;
        }

        const numericValue = Number(trimmedValue);
        if (Number.isNaN(numericValue) || numericValue <= 0) {
            delete params[key];
        }
    });

    return params;
};

const getDescripcionValue = (value) => {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number") return value;
    if (typeof value === "object") {
        return value.descripcion ?? value.Descripcion ?? value.nombre ?? value.Nombre ?? "";
    }
    return "";
};

const getTipoEntregaValue = (value) => {
    if (Array.isArray(value)) {
        const firstValue = value[0];
        if (firstValue == null) return "";
        if (typeof firstValue === "string") return firstValue;
        if (typeof firstValue === "object") {
            return firstValue.descripcion ?? firstValue.Descripcion ?? "";
        }
    }

    if (typeof value === "string") return value;
    if (typeof value === "object" && value != null) {
        return value.descripcion ?? value.Descripcion ?? "";
    }

    return "";
};

const getSellerDescriptionValue = (item) => {
    if (!item || typeof item !== "object") return "";

    const seller = item.seller ?? item.Seller ?? null;
    if (seller && typeof seller === "object") {
        const fromSellerObject =
            seller.descripcion
            ?? seller.Descripcion
            ?? seller.razonSocial
            ?? seller.RazonSocial
            ?? seller.nombre
            ?? seller.Nombre
            ?? "";

        if (fromSellerObject) return fromSellerObject;
    }

    return (
        item.descripcionSeller
        ?? item.DescripcionSeller
        ?? item.nombreSeller
        ?? item.NombreSeller
        ?? item.razonSocialSeller
        ?? item.RazonSocialSeller
        ?? ""
    );
};

const normalizedElementosPublicaciones = (publicaciones, transformObjectsToStrings = true) => {
    const elementos = publicaciones?.elementos ?? publicaciones?.content ?? [];
    return elementos.filter(item => item && typeof item === 'object').map(item => ({
        ...item,
        imagenes: item?.imagenes ?? item?.Imagenes ?? [],
        imagen: item?.imagenes?.[0] ?? item?.Imagenes?.[0] ?? null,
        descripcionUmbralStock: item?.descripcionUmbralStock ?? item?.DescripcionUmbralStock ?? "",
        estado: normalizeEstadoPublicacion(item?.estado ?? item?.Estado) || (item?.estado ?? item?.Estado),
        descripcionSeller: getSellerDescriptionValue(item),
        nombreSeller: item?.nombreSeller ?? item?.NombreSeller ?? getSellerDescriptionValue(item),
        marca: transformObjectsToStrings ? getDescripcionValue(item.marca) : (item.marca || ""),
        categoria: transformObjectsToStrings ? getDescripcionValue(item.categoria) : (item.categoria || ""),
        tipoPublicacion: transformObjectsToStrings ? getDescripcionValue(item.tipoPublicacion) : (item.tipoPublicacion || ""),
        tipoEntrega: transformObjectsToStrings ? getTipoEntregaValue(item.tipoEntrega) : (item.tipoEntrega?.[0] || item.tipoEntrega || "")
    }))
}

const toArray = (value, alternate) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(alternate)) return alternate;
  return [];
};

export const seModificaronImagenes = (boolean) => dispatch => {
  dispatch({
    type: SE_MODIFICARON_IMAGENES,
    payload: boolean
  });
}

export const setFiltroPublicacion = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_PUBLICACIONES,
    payload: filtro
  });
}

export const fetchPublicaciones = (params) => async dispatch => {
    dispatch({
        type: LOADING_PUBLICACIONES,
        payload: true
    });

    fetchPublicacionesApi(params).then((publicaciones) => {
        const payload = {
            elementos: normalizedElementosPublicaciones(publicaciones),
            cantidades: {
                activos: publicaciones?.activos ?? 0,
                enRevision: publicaciones?.enRevision ?? 0,
                conStockNoPublicados: publicaciones?.conStockNoPublicados ?? 0
            },
            cantidadTotal: publicaciones?.total ?? publicaciones?.Total ?? 0,
            cantidadPagina: publicaciones?.totalPages ?? publicaciones?.TotalPages ?? 0,
            numeroPagina: publicaciones?.page ?? publicaciones?.Page ?? 0
        };

        dispatch({
            type: FETCH_PUBLICACIONES,
            payload
        });
    }).catch(() => {
        dispatch({
            type: FETCH_PUBLICACIONES,
            payload: {
                elementos: [],
                cantidades: {
                    activos: 0,
                    pendientes: 0,
                    enRevision: 0,
                    pausadosConStock: 0,
                    pausadosSinStock: 0,
                    conStockNoPublicados: 0
                },
                cantidadTotal: 0,
                cantidadPagina: 0,
                numeroPagina: 0
            }
        });
    }).finally(() => {
        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });
    });
}

export const fetchPublicacionPorSkuMarket = async (skuMarket) => {
    return fetchPublicacionPorSkuMarketApi(skuMarket).then(publicacion => {
        return {
            ...publicacion,
            elementos: normalizedElementosPublicaciones(publicacion)
        }
    }).catch(() => {
        return [];
    })
}

export const fetchPublicacionesEncabezado = (params) => async dispatch => {
    dispatch({
        type: LOADING_PUBLICACIONES,
        payload: true
    });

    const requestParams = normalizeOptionalSellerParam({
        ...params,
        DireccionOrdenamiento: 1,
        EntidadOrdenamiento: "idPublicacion"
    });
    const requestKey = JSON.stringify(requestParams);
    const now = Date.now();
    const cacheWindowMs = 7000;
    if (
        requestKey === lastPublicacionesEncabezadoKey &&
        lastPublicacionesEncabezadoData &&
        (now - lastPublicacionesEncabezadoAt) < cacheWindowMs
    ) {
        dispatch({
            type: FETCH_PUBLICACIONES,
            payload: lastPublicacionesEncabezadoData
        });

        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });

        return;
    }

    fetchPublicacionesEncabezadoApi(requestParams).then((publicaciones) => {
        const cantidades = {
            activos: publicaciones?.cantidades?.activos ?? publicaciones?.cantidades?.Activos ?? publicaciones?.activos ?? publicaciones?.Activos ?? 0,
            pendientes: publicaciones?.cantidades?.pendientes ?? publicaciones?.cantidades?.Pendientes ?? publicaciones?.pendientes ?? publicaciones?.Pendientes ?? 0,
            enRevision: publicaciones?.cantidades?.enRevision ?? publicaciones?.cantidades?.EnRevision ?? publicaciones?.enRevision ?? publicaciones?.EnRevision ?? 0,
            pausadosConStock: publicaciones?.cantidades?.pausadosConStock ?? publicaciones?.cantidades?.PausadosConStock ?? publicaciones?.pausadosConStock ?? publicaciones?.PausadosConStock ?? 0,
            pausadosSinStock: publicaciones?.cantidades?.pausadosSinStock ?? publicaciones?.cantidades?.PausadosSinStock ?? publicaciones?.pausadosSinStock ?? publicaciones?.PausadosSinStock ?? 0,
            conStockNoPublicados: publicaciones?.cantidades?.conStockNoPublicados ?? publicaciones?.cantidades?.ConStockNoPublicados ?? publicaciones?.conStockNoPublicados ?? publicaciones?.ConStockNoPublicados ?? 0
        }
        const cantidadTotal = publicaciones?.cantidadTotal ?? publicaciones?.CantidadTotal ?? publicaciones?.total ?? publicaciones?.Total ?? 0;
        const cantidadPagina = publicaciones?.cantidadPagina ?? publicaciones?.CantidadPagina ?? publicaciones?.totalPages ?? publicaciones?.TotalPages ?? 0;
        const numeroPagina = publicaciones?.numeroPagina ?? publicaciones?.NumeroPagina ?? publicaciones?.page ?? publicaciones?.Page ?? 0;

        const payload = {
            elementos: normalizedElementosPublicaciones(publicaciones),
            cantidades,
            cantidadTotal,
            cantidadPagina,
            numeroPagina
        };

        lastPublicacionesEncabezadoData = payload;

        dispatch({
            type: FETCH_PUBLICACIONES,
            payload
        });
    }).catch(() => {
        const fallback = {
            elementos: [],
            cantidades: {
                activos: 0,
                pendientes: 0,
                enRevision: 0,
                pausadosConStock: 0,
                pausadosSinStock: 0,
                conStockNoPublicados: 0
            },
            cantidadTotal: 0,
            cantidadPagina: 0,
            numeroPagina: 0
        }

        lastPublicacionesEncabezadoData = fallback;

        dispatch({
            type: FETCH_PUBLICACIONES,
            payload: fallback
        });
    }).finally(() => {
        lastPublicacionesEncabezadoKey = requestKey;
        lastPublicacionesEncabezadoAt = Date.now();
        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });
    });
}

export const fetchTiposPublicacion = (idSeller) => async dispatch => {
  const req = fetchTipoPublicacionApi(idSeller);
  req.then((tipos) => {
    const listaTipos =
      Array.isArray(tipos?.tiposDePublicaciones) ? tipos.tiposDePublicaciones
        : Array.isArray(tipos?.tiposPublicaciones) ? tipos.tiposPublicaciones
          : Array.isArray(tipos?.elementos) ? tipos.elementos
            : [];

    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true
    });

    dispatch({
      type: FETCH_TIPOPUBLICACION,
      payload: listaTipos
    });
  })
}

export const loadedTipoPublicacion = (value) => dispatch => {
  dispatch({
    type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    payload: value
  });
}

export const fetchPublicacion = (id, idSeller) => async dispatch => {
    dispatch({
        type: LOADING_PUBLICACIONES,
        payload: true
    });

    if (typeof id !== 'undefined' && typeof idSeller !== 'undefined') {
        return fetchPublicacionApi(id)
            .then(publicacion => {
                const normalizePublicacion = {
                    ...publicacion,
                    elementos: normalizedElementosPublicaciones(publicacion, false)
                };
                const payload = mapPublicacion(normalizePublicacion.elementos.shift())
                dispatch({
                    type: FETCH_PUBLICACION,
                    payload: payload
                });
            })
            .catch(err => {
                // si querés podés setear una publicación vacía o mostrar toast aquí
            })
            .finally(() => {
                dispatch({
                    type: LOADING_PUBLICACIONES,
                    payload: false
                });
            });
    } else {
        const payload = nuevaPublicacion();
        if (idSeller != null && idSeller !== '') {
            const n = Number(idSeller);
            if (!Number.isNaN(n)) {
                payload.idSeller = n;
            }
        }
        dispatch({
            type: FETCH_PUBLICACION,
            payload
        });
        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });
    }
};

export const editPublicacion = (publicacion) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: EDIT_PUBLICACION,
      payload: publicacion
    });
    resolve();
  });
}

export const fetchVariaciones = () => async dispatch => {
  const req = fetchVariacionesApi();
  req.then((variaciones) => {

    dispatch({
      type: FETCH_ESTADOSVARIACIONES,
      payload: variaciones.estados
    });
  })
}

export const fetchMarcas = (descripcion = "", id = null) => async (dispatch, getState) => {
  const q = (descripcion ?? "").trim();
  // Evitar llamadas vacías/repetidas de react-select ("" al abrir/cerrar),
  // pero permitir la carga inicial cuando todavía no hay opciones.
  if (q.length === 0 && !id) {
    const existing = getState?.()?.publicaciones?.marcas;
    if (Array.isArray(existing) && existing.length > 0) return;
  }

  const existingMarca = Array.isArray(getState?.()?.publicaciones?.marcas)
    ? getState().publicaciones.marcas.find(marca => String(marca?.value) === String(id))
    : null;
  const marcaDescripcion = q || existingMarca?.label || existingMarca?.descripcion || "";
  const req = id ? fetchMarcaApi(marcaDescripcion) : fetchMarcasApi(q);
  req.then((marcas) => {
    const marcasArray = marcas?.elementos ?? marcas?.marcas ?? marcas?.Marcas ?? marcas?.content ?? marcas?.Content ?? (Array.isArray(marcas) ? marcas : []);

    let options = marcasArray
      .map((marca) => ({
        value: marca?.codigo ?? marca?.Codigo ?? 0,
        label: marca?.descripcion ?? marca?.Descripcion ?? ""
      }))
      .filter((item) => item.label !== "");

    if (id) {
      options = options.filter(item => item.value === Number(id));
    }

    dispatch({
      type: FETCH_MARCAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_MARCAS,
      payload: []
    });
  });
}

export const getMarcaById = async (idMarca, descripcionMarca = "") => {
  try {
    const response = await fetchMarcaApi(descripcionMarca);
    const data = response ?? {};
    if (data?.marca) {
      return data;
    }

    const marcasList = Array.isArray(data?.marcas) ? data.marcas : Array.isArray(data?.Marcas) ? data.Marcas : Array.isArray(data?.elementos) ? data.elementos : Array.isArray(data?.Elementos) ? data.Elementos : null;

    const marcaFromList = Array.isArray(marcasList)
      ? (marcasList.find(m => String(m?.codigo ?? m?.Codigo) === String(idMarca)) ?? marcasList[0])
      : null;

    const marca = data?.Marca ?? marcaFromList ?? data;
    return {
      ...data,
      marca: {
        codigo: marca?.codigo ?? marca?.Codigo ?? 0,
        descripcion: marca?.descripcion ?? marca?.Descripcion ?? ""
      }
    };
  } catch { }
}

export const fetchCategorias = (descripcion = "") => async (dispatch, getState) => {
  const q = (descripcion ?? "").trim();
  // Evitar llamadas vacías/repetidas de react-select ("" al abrir/cerrar),
  // pero permitir la carga inicial cuando todavía no hay opciones.
  if (q.length === 0) {
    const existing = getState?.()?.publicaciones?.categorias;
    if (Array.isArray(existing) && existing.length > 0) return;
  }

  const req = fetchCategoriasApi(q);
  req.then((categorias) => {
    const categoriasArray =
      Array.isArray(categorias?.elementos) ? categorias.elementos
        : Array.isArray(categorias?.Elementos) ? categorias.Elementos
          : Array.isArray(categorias?.categorias) ? categorias.categorias
            : Array.isArray(categorias?.Categorias) ? categorias.Categorias
              : Array.isArray(categorias?.content) ? categorias.content
                : Array.isArray(categorias?.Content) ? categorias.Content
                  : Array.isArray(categorias) ? categorias
                    : [];
    const options = categoriasArray
      .map((categoria) => ({
        value: categoria?.id ?? categoria?.Id ?? categoria?.codigo ?? categoria?.Codigo ?? 0,
        label: categoria?.descripcion ?? categoria?.Descripcion ?? ""
      }))
      .filter((item) => item.label !== "");

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_CATEGORIAS,
      payload: []
    });
  });
}

export const fetchCategoria = (codigo) => async dispatch => {
  const req = fetchCategoriaApi(codigo);

  req.then((response) => {
    const descripcion = response?.subFamilia?.descripcion
      ?? response?.subFamilia?.Descripcion
      ?? response?.descripcion
      ?? "";
    let options = { value: descripcion, label: descripcion };

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  }).catch(() => {
    dispatch({
      type: FETCH_CATEGORIAS,
      payload: []
    });
  });
}

export const fetchMotivosRevision = () => async dispatch => {
  const req = fetchMotivosRevisionApi();

  req.then((response) => {
    const motivos = toArray(response?.motivos, response?.Motivos);
    dispatch({
      type: FETCH_MOTIVOS,
      payload: motivos
    })
  }).catch(() => {
    dispatch({
      type: FETCH_MOTIVOS,
      payload: []
    });
  });
}

export const resetPublicaciones = () => dispatch => {
dispatch({
  type: RESET_PUBLICACIONES,
  payload: resetPublicacion() 
});
};


export const resetListPublicaciones = () => dispatch => {
  dispatch({
    type: RESET_LIST_PUBLICACIONES,
    payload: []
  });
}

export const updateListPublicaciones = (publicacionesArray, publicacion) => async (dispatch) => {
    // Validación defensiva
    if (!publicacionesArray || !Array.isArray(publicacionesArray.elementos)) {
        console.error("updateListPublicaciones: publicacionesArray.elementos es inválido", publicacionesArray);
        return;
    }

    const elementos = publicacionesArray.elementos.map(item => {
        if (item.idPublicacion === publicacion.idPublicacion) {
            return {
                ...item,
                titulo: publicacion.titulo,
                skuSeller: publicacion.skuSeller,
                skuMarket: publicacion.skuMarket,
                categoria: publicacion.descripcionCategoria,
                precioLista: publicacion.precioLista,
                precioPromocional: publicacion.precioPromocional,
                estado: getIdEstadoPublicacion(publicacion.estado),
                marca: publicacion.descripcionMarca,
                tipoEntrega: publicacion.tipoEntrega[0] === 1 
                    ? "Envio a domicilio o sucursal correo" 
                    : "Retiro en sucursal",
                envioGratis: publicacion.envioGratis,
                tipoPublicacion: publicacion.tipoPublicacion?.descripcion ?? "",
                stock: publicacion.stock
            };
        }
        return item;
    });

    const updatedPublicacionesArray = {
        ...publicacionesArray,
        elementos,
    };

    dispatch({
        type: 'UPDATE_PUBLICACIONES_LIST',
        payload: updatedPublicacionesArray,
    });
};



export const setImagesUploader = (images, values) => dispatch => {
    dispatch({
        type: SET_IMAGES_UPLOADER,
        payload: images
    });

    dispatch({
        type: HAY_CAMBIOS_EN_IMAGENES,
        payload: values
    });
}


export const resetMarcaYCategoria = () => dispatch => {
  dispatch({
      type: RESET_MARCA_Y_CATEGORIA,
      payload: {
          marca: { label: '', value: '' },
          categoria: { label: '', value: '' }
      }
  });
};


export const updateListPublicacionesEstado = (idPublicacion, estado) => (dispatch, getState) => {
  const { publicaciones } = getState().publicaciones;

  const elementosActualizados = publicaciones.elementos.map(item =>
      item.idPublicacion === idPublicacion
          ? { ...item, estado }
          : item
  );

  const publicacionesActualizadas = {
      ...publicaciones,
      elementos: elementosActualizados,
  };

  dispatch({
      type: UPDATE_PUBLICACIONES_ESTADO,
      payload: publicacionesActualizadas,
  });
};

export const fetchTiposAlicuotasIva = () => async (dispatch, getState) => {
  const existing = getState?.()?.publicaciones?.tiposAlicuotaIva;
  if (Array.isArray(existing) && existing.length > 0) {
    return existing;
  }

  const req = fetchAlicuotaIvaApi();
  req.then((response) => {
    const tiposAlicuotaIva = response?.data?.tiposAlicuotaIva ?? response?.data?.elementos ?? response?.data?.content ?? [];

    dispatch({
      type: FETCH_ALICUOTA_IVA,
      payload: tiposAlicuotaIva,
    });

    return tiposAlicuotaIva;
  });
}



export const fetchAtributosCategoria = (IdSubFamilia) => async dispatch => {

    try {
        const response = await fetchAtributosCategoriaApi(IdSubFamilia);

        const listAtributos = toArray(response?.listAtributos, response?.ListAtributos);
        dispatch({
            type: FETCH_ATRIBUTOSCATEGORIA,
            payload: listAtributos,
        });

        return listAtributos; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchAtributosPorCategoriaAgrupamiento = (IdSubFamilia, idAgrupacion, Descripcion, noIncluir) => async dispatch => {

    try {
        const response = await fetchAtributosPorCategoriaAgrupamientoApi(IdSubFamilia, idAgrupacion, Descripcion, noIncluir);

        const listAtributos = toArray(response?.listAtributos, response?.ListAtributos);
        dispatch({
            type: FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO,
            payload: listAtributos,
        });

        return listAtributos; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchValoresAtributo = (idAtributo, descripcion) => async dispatch => {

    try {
        const response = await fetchValoresAtributoApi(idAtributo, descripcion);

        const listValores = toArray(response?.listValores, response?.ListValores);
        dispatch({
            type: FETCH_VALORESATRIBUTO,
            payload: listValores,
        });

        return listValores; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchEstructuraAtributosValores = ({ codProducto, idCategoria }) => async (dispatch) => {
    if (codProducto == null) {
        codProducto = "";
    }

    if (idCategoria == null) {
        idCategoria = 0;
    }

    try {
       const response = await fetchEstructuraAtributosValoresApi(codProducto, idCategoria);

        const listaEstructura = toArray(response?.listaEstructura, response?.ListaEstructura);
        dispatch({
            type: FETCH_ESTRUCTURAATRIBUTOSVALORES,
            payload: listaEstructura,
        });

        return listaEstructura; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};


export const fetchAgrupamientos = (idCategoria) => async dispatch => {

    try {
        const response = await fetchAgrupamientosApi(idCategoria);

        const listAgrupamiento = toArray(response?.listAgrupamiento, response?.ListAgrupamiento);
        dispatch({
            type: FETCH_AGRUPAMIENTOS,
            payload: listAgrupamiento,
        });

        return listAgrupamiento; // <-- Necesario para await en el componente

    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const setEstructuraAtributosValores = (productoValores, huboCambios) => dispatch => {
    dispatch({
        type: SET_PRODUCTOVALORES,
        payload: productoValores
    });
    dispatch({
        type: SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS,
        payload: huboCambios
    });
}

export const limpiarEstructuraAtributosValores = () => dispatch => {
    dispatch({
        type: FETCH_ESTRUCTURAATRIBUTOSVALORES,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}

export const limpiarAgrupamientos = () => dispatch => {
    dispatch({
        type: FETCH_AGRUPAMIENTOS,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}

export const limpiarProductoValores = () => dispatch => {
    dispatch({
        type: SET_PRODUCTOVALORES,
        payload: null,
    });

    return null; // <-- Necesario para await en el componente
}
